<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Crear repuesto /
        <router-link to="/repuestos"
          ><a href="#">Regresar a repuestos</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <div class="form-group">
            <label>Código</label>
            <input
              v-model="codigo"
              class="form-control"
              placeholder="Digite el código del repuesto"
            />
          </div>
          <div class="form-group">
            <label>Referencia</label>
            <input
              v-model="referencia"
              class="form-control"
              placeholder="Digite la referencia"
            />
          </div>
          <div class="form-group">
            <label>Cantidad</label>
            <input
              type="number"
              v-model="cantidad"
              class="form-control"
              placeholder="Digite la cantidad"
            />
          </div>

          <button
            @click="checkForm"
            style="width: 100%;"
            class="btn btn-primary"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'crear-repuesto',
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      codigo: '',
      referencia: '',
      cantidad: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    checkForm() {
      if (!this.codigo) {
        this.$noty.error('El código es requerido');
      } else if (!this.referencia) {
        this.$noty.error('La referencia es requerida');
      } else if (!this.cantidad) {
        this.$noty.error('La cantidad es requerida');
      } else if (this.cantidad < 1) {
        this.$noty.error(
          'La cantidad debe ser un número mayor a cero'
        );
      } else {
        this.saveInformation();
      }
    },
    saveInformation() {
      this.loading = true;
      let data = {
        codigo: this.codigo.toUpperCase(),
        referencia: this.referencia.toUpperCase(),
        cantidad: this.cantidad,
      };
      ServiceApi.post('/repuesto/create', data)
        .then(response => {
          if (response.data.status) {
            this.$noty.success('Repuesto creado con éxito');
            this.loading = false;
            this.$router.push('/repuestos');
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al crear el repuesto, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
  },
};
</script>
